module.exports = __webpack_public_path__ + "static/media/bell.1b73b958.svg";